<template>

 <div> 
   <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 ">
     <jet-button @click="back"  class="bg-blue-500 rounded  text-white hover:bg-blue-500  hover:no-underline px-2 cursor-pointer  text-sm" >Back</jet-button>
         &nbsp;

    </div>

    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 mt-2">
      <div class="w-full">
        <div class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
            
          <!-- <div class="text-lg font-bold ">Create {{moduleName}}</div> -->

            <form @submit.prevent="update">
              <BsEdit :createDef="createDef" :routeDef="moduleRoute" :modelData="modelData" ref="formRenderer"> </BsEdit>
              

            <div class="panel-footer mt-2">
                
                    <jet-button type="submit" @click="update" class=" bg-yellow-500  hover:bg-yellow-500  cursor-pointer rounded text-sm pl-2 pr-2 pt-1 pb-1 text-white hover:no-underline"> Update </jet-button>
           
            </div>

              </form>




        </div>
      </div>
    </div>

 </div>
</template>

<script>

import BsEdit from "@/Base/BsEdit.vue";
import JetNavLink from '@/Jetstream/NavLink.vue'
import JetButton from "@/Jetstream/Button.vue";



const modelData = {};

export default {
  props: {
    createDef: Array,
    moduleRoute: String,
    moduleName:  String,
    modelData:{
        type: Object,
        default: () => ({})
    },
  },
  components: {
    BsEdit,
    JetNavLink,
    JetButton,

  },
  data: function () {
    return {
    title:this.moduleRoute+" Create"

    };
  },
  methods: {
    checkAction()
    {
      return (this.modelData.hasOwnProperty("id") && this.modelData.id != "")
    },
    
    update()
    {
        
        this.$inertia.put(route(this.moduleRoute+'.update',this.modelData.id),this.$refs.formRenderer.formData)
        
    },    
    back() {
            this.$inertia.get('/'+this.moduleRoute);
    },

  },
  mounted() {
  },
};
</script>

<style>
</style>